import React, {useState} from 'react';
import Menu from '../Menu';
import Copyright from '../Sidebar/Copyright';
import {useSiteMetadata} from "../../hooks";

const Navigation = () => {
  const {copyright} = useSiteMetadata();
  const [menuState, setMenuState] = useState(false);

  const toggleMenuState = (e) => {
    e.preventDefault();
    setMenuState(!menuState); // update menu state
  }

  return (
    <>
      <button
        className={`button-burger ${menuState ? 'active' : ''} app-nav`}
        aria-label="Show menu"
        onClick={toggleMenuState}
      >
        <span className="button-burger__container-bars">
          <span className="button-burger__bar"/>
          <span className="button-burger__bar"/>
          <span className="button-burger__bar"/>
        </span>
      </button>
      <div className={`app-bar ${menuState ? 'menu-active' : ''}`}>
        <Menu />
        <Copyright copyright={copyright} isMenu={true} />
      </div>
    </>
  );
};

export default Navigation;
